export const SERVER_URL = 'https://prod.admin.leaf-wellness.org/api/v1';
